module.exports = __webpack_public_path__ + "static/media/jarvis.1a6af08a.jpg";